import { postRequest } from "../apiHelpers";
import { login } from "../pathApi";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const callLogin = createAsyncThunk(login, async (body) => {
	try {
		const response = await postRequest({ url: login, data: body });
		return response;
	} catch (error) {
		throw error
	}
});